import { Link, Navigate } from 'react-router-dom';
import { Clock3, LogOut, Mail, ShieldCheck, ShoppingBag, UserRound } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

function formatDate(value) {
  if (!value) {
    return 'Not available';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return 'Not available';
  }

  return parsed.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

export default function ProfilePage() {
  const { user, loading, logout } = useAuth();

  if (loading) {
    return (
      <section className="profile-page">
        <article className="profile-card">
          <h1>Loading profile...</h1>
        </article>
      </section>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const displayName = user.displayName || 'Pixel Shopper';
  const email = user.email || 'Not available';
  const initials = displayName.slice(0, 1).toUpperCase();

  return (
    <section className="profile-page">
      <article className="profile-hero">
        <div className="profile-avatar" aria-hidden="true">
          {initials}
        </div>
        <div className="profile-copy">
          <p className="profile-kicker">My Profile</p>
          <h1>{displayName}</h1>
          <p>{email}</p>
        </div>

        <div className="profile-hero-actions">
          <Link to="/product" className="solid-btn">
            <ShoppingBag size={15} /> Shop Product
          </Link>
          <button type="button" className="ghost-btn" onClick={logout}>
            <LogOut size={15} /> Logout
          </button>
        </div>
      </article>

      <div className="profile-grid">
        <article className="profile-card">
          <h2>Account Details</h2>
          <div className="profile-list">
            <div className="profile-row">
              <span>
                <UserRound size={14} /> Name
              </span>
              <strong>{displayName}</strong>
            </div>
            <div className="profile-row">
              <span>
                <Mail size={14} /> Email
              </span>
              <strong>{email}</strong>
            </div>
            <div className="profile-row">
              <span>
                <ShieldCheck size={14} /> Email Verified
              </span>
              <strong className={user.emailVerified ? 'good' : 'warn'}>
                {user.emailVerified ? 'Verified' : 'Not verified'}
              </strong>
            </div>
            <div className="profile-row">
              <span>
                <Clock3 size={14} /> Joined
              </span>
              <strong>{formatDate(user.metadata?.creationTime)}</strong>
            </div>
          </div>
        </article>

        <article className="profile-card">
          <h2>Quick Actions</h2>
          <div className="profile-actions">
            <Link to="/cart" className="ghost-btn">
              View Cart
            </Link>
            <Link to="/checkout" className="ghost-btn">
              Continue Checkout
            </Link>
            <Link to="/product" className="ghost-btn">
              Browse Colors
            </Link>
          </div>

          <p className="profile-note">
            Need help with your order? Contact support on WhatsApp: <strong>+91 9499473347</strong>
          </p>
        </article>
      </div>
    </section>
  );
}
